import React, { useState, useEffect } from "react";

import Swal from "sweetalert2";

const Subscribe = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);

  // Animation trigger on component mount
  useEffect(() => {
    setAnimateIn(true);
  }, []);

  // Handle email change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Button animation triggered by state
    const button = e.target.querySelector("button");
    button.classList.add("animate-submit");

    try {
      const response = await fetch(
        "https://ardorbiomed.com/api/api/Subscribe/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: email }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Subscribed Successfully",
          text: "Thank you for subscribing to our newsletter!",
        });
        setEmail("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Please try again later.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred. Please try again later.",
      });
    } finally {
      setIsSubmitting(false);
      button.classList.remove("animate-submit");
    }
  };
  return (
    <div>
      <section
        className="newsletter-section py-5 position-relative overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ef 100%)",
        }}
      >
        <div className="container position-relative" style={{ zIndex: 5 }}>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div
                className={`newsletter-card newsletter-glow rounded-lg p-5 bg-white scroll-animate ${
                  animateIn ? "animate-in" : ""
                }`}
                style={{ borderRadius: "16px" }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="newsletter-content">
                      <h3 className="fw-bold mb-3 gradient-text pulse-animation">
                        Stay Connected
                      </h3>
                      <p className="text-muted mb-0 stagger-item stagger-delay-1">
                        Get exclusive updates and offers directly to your inbox.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <form
                      id="mc-form"
                      onSubmit={handleSubmit}
                      className="newsletter-form stagger-item stagger-delay-2"
                    >
                      <div className="input-group animated-border">
                        <input
                          className="form-control py-3 px-4"
                          style={{
                            borderRadius: "8px 0 0 8px",
                            border: "2px solid #e2e8f0",
                            borderRight: "none",
                          }}
                          id="mc-email"
                          type="email"
                          autoComplete="off"
                          placeholder="Enter your email address"
                          value={email}
                          onChange={handleEmailChange}
                          required
                        />
                        <button
                          className="gradient-btn"
                          id="mc-submit"
                          disabled={isSubmitting}
                          type="submit"
                        >
                          {isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Sending...
                            </>
                          ) : (
                            <span className="d-flex align-items-center">
                              Subscribe
                              <i className="ion-paper-airplane ms-2"></i>
                            </span>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Wave background */}
        {/* <div
          className="wavy-bg"
          style={{
            height: "15px",
            width: "100%",
            position: "absolute",
            bottom: "0",
          }}
        ></div> */}
      </section>
    </div>
  );
};

export default Subscribe;
